import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  mockOrderEligibilitiesWithMiles,
  mockOrderEligibilitiesWithMilesForTwoPax,
  mockOrderEligibilitiesWithMilesForTwoPaxWithoutPenalty,
  mockOrderEligibilitiesWithMilesWithoutCancellation,
  mockOrderWithMiles,
  mockOrderWithMilesForTwoPax,
  mockOrderWithMilesWithoutCancellation,
  orderCancelAndRefundWithMiles,
  orderCancelAndRefundWithMilesWithoutCancellation,
  orderMockNotEligibleToRefund,
} from '../../../mock/data';
import {
  noActiveItineraryWarning,
  servicesCancelledWarning,
  servicesNotRefundableWarning,
} from '../../../mock/dictionaries';

/**
 * Mocks for refund with miles and cash
 */
export const refundWithMilesMock: MockMap = {
  retrieveOrder: [createMockData(mockOrderWithMiles), createMockData(orderMockNotEligibleToRefund, [], [noActiveItineraryWarning])],
  getOrderEligibilities: [createMockData(mockOrderEligibilitiesWithMiles)],
  cancelAndRefundOrder: [createMockData(orderCancelAndRefundWithMiles)]
};

/**
 * Mocks for refund with miles and cash without cancellation fees
 */
export const refundWithMilesWithoutCancellationFeeMock: MockMap = {
  retrieveOrder: [createMockData(mockOrderWithMilesWithoutCancellation)],
  getOrderEligibilities: [createMockData(mockOrderEligibilitiesWithMilesWithoutCancellation, [], [servicesNotRefundableWarning])],
  cancelAndRefundOrder: [createMockData(orderCancelAndRefundWithMilesWithoutCancellation, [], [servicesCancelledWarning])]
};

/**
 * Mocks for refund with miles and cash for a subset of passengers
 */
export const refundWithMilesForSubsetOfPassengersMock: MockMap = {
  retrieveOrder: [createMockData(mockOrderWithMilesForTwoPax)],
  getOrderEligibilities: [createMockData(mockOrderEligibilitiesWithMilesForTwoPax)],
  cancelAndRefundOrder: [createMockData(orderCancelAndRefundWithMiles)]
};

/**
 * Mocks for refund with miles and cash for a subset of passengers without cancellation fees
 */
export const milesRefundForSubsetOfPassengersWithoutPenaltyMock: MockMap = {
  retrieveOrder: [createMockData(mockOrderWithMilesForTwoPax)],
  getOrderEligibilities: [createMockData(mockOrderEligibilitiesWithMilesForTwoPaxWithoutPenalty)],
  cancelAndRefundOrder: [createMockData(orderCancelAndRefundWithMilesWithoutCancellation)]
};
